var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { css, mq, styled } from "../../utils";
import ContactMobile from './ContactMobile';
var StyledMobileHeader = styled.div(function (_a) {
    var space = _a.theme.space;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    align-items: center;\n    justify-content: space-between;\n    padding: ", " ", ";\n\n    ", ";\n  "], ["\n    position: relative;\n    align-items: center;\n    justify-content: space-between;\n    padding: ", " ", ";\n\n    ", ";\n  "])), space[1], space[3], mq({
        display: ['flex', 'none'],
    }));
});
var StyledLogoContainer = styled.div(function (_a) {
    var variant = _a.variant, space = _a.theme.space;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    padding: ", " ", ";\n\n    & > a {\n      display: inline-block;\n    }\n\n    svg {\n      height: 24px;\n    }\n\n    ", ";\n  "], ["\n    ", "\n    padding: ", " ", ";\n\n    & > a {\n      display: inline-block;\n    }\n\n    svg {\n      height: 24px;\n    }\n\n    ", ";\n  "])), variant === 'ghost'
        ? "\n        position: absolute;\n        transform: translateY(100%);\n        right: 0;\n        bottom: 0;\n      "
        : "\n        display: flex;\n        justify-content: flex-end;\n        ", space[3], space[3], mq({
        display: ['flex', 'none'],
    }));
});
var HeaderMobile = function (_a) {
    var logo = _a.logo, contactLabel = _a.contactLabel, contactPhone = _a.contactPhone, contactPhoneHref = _a.contactPhoneHref, variant = _a.variant;
    return (React.createElement(React.Fragment, null,
        contactLabel && contactPhone && (React.createElement(StyledMobileHeader, null,
            React.createElement(ContactMobile, { label: contactLabel, phone: contactPhone, phoneHref: contactPhoneHref }))),
        React.createElement(StyledLogoContainer, { variant: variant }, logo)));
};
export default HeaderMobile;
var templateObject_1, templateObject_2;
//# sourceMappingURL=HeaderMobile.js.map